export const API_URL = window.API_URL
export const CLIENT_ROOT_URL = window.CLIENT_ROOT_URL
export const API_IATACODES = window.API_IATACODES
export const FOLDER = window.FOLDER

// Colocar en package.json cuando se despliega:  "homepage": "ecompras", despues de la version.


// WEBPACK FOOTER //
// ./src/actions/index.js